import { Icon } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { SerializedBoardData, shredBoard } from "../../../../models/board";
import { ModalProps } from "../../ModalManager";
import { ConfirmModal } from "../ConfirmModal";

export type ConfirmShredBoardModalProps = {
  boardData: SerializedBoardData
} & ModalProps;

export function ConfirmShredBoardModal({ ...props }: ConfirmShredBoardModalProps) {
  const { t, i18n } = useTranslation();

  const handleOnClick = async () => {
    await shredBoard(props.boardData.uid);
    props.closeModal();
  }

  return (
    <ConfirmModal
      title={t("warning")}
      subtitle={t("modal.shredBoard.subtitle")}
      description={t("modal.shredBoard.description")}
      closeModal={props.closeModal}
      onConfirm={handleOnClick}
      confirmButtonText={t("modal.button.shred")}
    >
      <Icon color="danger" size="medium">
        <i className="icon-trash is-large" aria-hidden="true"></i>
      </Icon>
    </ConfirmModal>
  )
}
